import printLogService from '@/api/print-log-service';
import { endOfMonth, format, startOfMonth } from 'date-fns';

export const getDefaultPrintReportFilterParams = () => ({
  date_from: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
  date_to: format(endOfMonth(new Date()), 'yyyy-MM-dd'),
});

const state = {
  printReport: null,
  printReportFilterParams: getDefaultPrintReportFilterParams(),
};

const mutations = {
  SET_PRINT_REPORT(state, data) {
    state.printReport = data;
  },

  SET_FILTER_PARAMS(state, params) {
    state.printReportFilterParams = params;
  },
};

const actions = {
  fetchPrintReport({ state, commit }, params) {
    commit('SET_FILTER_PARAMS', params);
    return printLogService.getReport(params).then((res) => {
      commit('SET_PRINT_REPORT', res.data);
      if (params.page !== state.printReportFilterParams.page) {
        window.scrollTo(0, 0);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
